import { CleaningServicesOutlined } from '@mui/icons-material';
import { Card, CardContent, Chip, Skeleton, Stack, Typography } from '@mui/material';
import { useSiivousStatus } from '@/hooks/useSiivousStatus';
import { useToastError } from '@/hooks/useToastError';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { updateAsSiivottu, updateAsSiivoamatta } from '@/services/siivousService';

const SiivousStatus = ({ tuoteId }) => {
  const { status, error, setStatus } = useSiivousStatus(tuoteId);
  const { t } = useTranslation();
  useToastError(error, t('siivousStatus.fetchError'));

  const onSetSiivottuClick = async ({ status }) => {
    if (!status) return;
    const prev = status;

    setStatus('SIIVOTTU');

    try {
      await updateAsSiivottu(tuoteId);
    }
    catch (error) {
      toast.error(t('siivousStatus.updateError'));
      setStatus(prev);
    }
  };

  const onSetSiivoamattaClick = async ({ status }) => {
    if (!status) return;
    const prev = status;

    setStatus('SIIVOAMATTA');

    try {
      await updateAsSiivoamatta(tuoteId);
    }
    catch (error) {
      toast.error(t('siivousStatus.updateError'));
      setStatus(prev);
    }
  };

  if (error) return null;

  if (tuoteId == null || status == null) {
    return <Skeleton variant="text" height="2em" width="95%" sx={{ paddingTop: '1em' }} />;
  }

  return (
    <React.Fragment>
      <Card sx={{ marginTop: '1em' }}>
        <CardContent>
          <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '100%' }}>
            <CleaningServicesOutlined />
            <Typography sx={{ flex: 1 }}>
              {t('siivousStatus.cleaning')}
            </Typography>
            <Typography>
              { status === 'SIIVOTTU' && t('siivousStatus.cleaned') }
              { status === 'SIIVOAMATTA' && t('siivousStatus.notCleaned') }
              { status === 'VARAUS' && t('siivousStatus.reserved') }
            </Typography>
          </Stack>
          { status === 'SIIVOTTU' && (
            <Chip
              label={t('siivousStatus.cleaned')}
              color="success"
              sx={{ width: '100%', marginTop: '1em' }}
              onClick={() => onSetSiivoamattaClick({ status })}
            />
          )}
          { status === 'SIIVOAMATTA' && (
            <Chip
              label={t('siivousStatus.notCleaned')}
              color="warning"
              sx={{ width: '100%', marginTop: '1em' }}
              onClick={() => onSetSiivottuClick({ status })}
            />
          )}
          { status === 'VARAUS' && (
            <Chip
              label={t('siivousStatus.reserved')}
              sx={{ width: '100%', marginTop: '1em' }}
            />
          )}
        </CardContent>
      </Card>
    </React.Fragment>
  );
};

export default SiivousStatus;
